export const initUiNotification = () => {
  $(".js-notification-close").on("click", function() {
    $(this)
      .closest(".ui-notification")
      .fadeOut();
  });
};
